/** @jsxRuntime classic */
/** @jsx jsx */
import { gql } from '@apollo/client';
import { graphql } from 'gatsby';
import { jsx } from 'theme-ui';
import { Trans } from '@lingui/macro';
import Product_fullName from '../../fragments/Product/fullName';
import ShoppingCartButton from './ShoppingCartButton';
import useSnipcart from '../../useSnipcart';
import useLink from '@bottlebooks/gatsby-theme-event/src/useLink';
export default function ProductSnipcartButton({ product, ...rest }) {
  const { isItemInCart, canAddMoreProducts } = useSnipcart();
  if (isItemInCart(product.productId))
    return (
      <ProductSnipcartButtonBase
        product={product}
        variant="outline"
        disabled
        {...rest}
      >
        <Trans>Already in cart</Trans>
      </ProductSnipcartButtonBase>
    );

  if (!canAddMoreProducts)
    return (
      <ProductSnipcartButtonBase
        product={product}
        variant="outline"
        disabled
        {...rest}
      >
        <Trans>Cart is full</Trans>
      </ProductSnipcartButtonBase>
    );

  return (
    <ProductSnipcartButtonBase product={product} {...rest}>
      <Trans>Request sample</Trans>
    </ProductSnipcartButtonBase>
  );
}

function ProductSnipcartButtonBase({ product, children, ...rest }) {
  const link = useLink();
  // Fallback to relative URL if BASE_URL is not set.
  const baseUrl = process.env.BASE_URL || '';
  const productLink =
    baseUrl +
    link.product({
      productId: product.productId,
      exhibitorId: product.exhibitorId,
    });
  return (
    <ShoppingCartButton
      data-item-id={product.inventoryId || product.productId}
      data-item-url={productLink}
      data-item-name={product.fullName}
      data-item-description={product.description}
      data-item-image={product.shopImage?.fixed?.src}
      {...rest}
      className={`snipcart-add-item ${rest.className}`}
    >
      {children}
    </ShoppingCartButton>
  );
}

export const fragment = graphql`
  fragment bb_ProductSnipcartButton on Bottlebooks_Product {
    inventoryId
    productId
    description
    shopImage: bottleImage {
      fixed(width: 80, height: 80, crop: PAD, background: "#FFF0") {
        src
      }
    }
    ...bb_Product_fullName
  }
`;

ProductSnipcartButton.fragment = gql`
  fragment ProductSnipcartButton on Product {
    inventoryId
    productId
    description
    shopImage: bottleImage {
      fixed(width: 80, height: 80, crop: PAD, background: "#FFF0") {
        src
      }
    }
    ...Product_fullName
  }
  ${Product_fullName.fragment}
`;
